"use client";

import { Check } from "lucide-react";

interface SaveStatusIndicatorProps {
  lastSaved: Date | null;
}

export default function SaveStatusIndicator({ lastSaved }: SaveStatusIndicatorProps) {
  if (!lastSaved) return null;

  const timeAgo = () => {
    const seconds = Math.floor((Date.now() - lastSaved.getTime()) / 1000);
    if (seconds < 5) return "just now";
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    return "recently";
  };

  return (
    <span className="text-sm text-muted-foreground flex items-center gap-1">
      <Check className="h-3 w-3" />
      Draft saved locally {timeAgo()}
    </span>
  );
}
